export const PRODUCT_SELECT_ACTION_PREFIX = 'product.select:';
export const PRODUCT_FOLLOWUP_ACTION_PREFIX = 'product.followup:';
export const PRODUCT_SIMILAR_ACTION_PREFIX = 'product.similar:';
export const CART_ADD_ACTION_PREFIX = 'cart.add:';
export const PRODUCT_ID_FROM_ASSET_PATTERN = /\/(\d{6,12}r?)\.(?:jpe?g|png|webp)(?:\?|$)/i;
